<script setup lang="ts">
import type { NovaContainerPostPageProps } from './NovaContainerPostPage.types'
import { PostContentsType } from '@store'
import { NovaBoxPost } from '#components'

const props = defineProps<NovaContainerPostPageProps>()

const { t } = useI18n()
const { onPage } = useShowPostErrorMessage()
const postStore = usePostStore()

onBeforeMount(async () => {
  if (props.post) {
    await postStore.fetchCommentsAndReplies(
      {
        ...initPostState.commentsAndReplies.payload,
        cmtyNttSn: props.cmtyNttSn,
      },
      true
    )
  }
})

if (props.err) {
  onPage(props.cmtyNttSn, props.err)
}
</script>

<template>
  <div class="page-posts-detail">
    <NovaBoxPost
      v-if="post && post.bkFlag === '0'"
      :source="post"
      :view-type="PostContentsType.DETAIL"
    />

    <NovaBoxEmptyMessage
      v-if="!post || (post && post.bkFlag === '1')"
      :message="t('statusMessages.postDetail.error.notFound')"
      :fill="true"
    />
  </div>
</template>

<style scoped lang="scss"></style>
